import React from 'react'
import dynamic from 'next/dynamic'

import {LazyLoad} from '@lib/LazyLoad'
import Meta from '@components/Meta'

const MainLayout = dynamic(() => import('@components/MainLayout'))
const GetStarted = dynamic(() => import('@components/GetStarted'))

export default function CareerPolicy() {
  return (
    <React.Fragment>
      <Meta title='Privacy notice for Job Applicants, Candidates and Interns – Data Science Consultant Thailand | Data Wow in Bangkok' />

      <div className='Document'>
        <div className='Document__hero'>
          <div className='container'>
            <h1>
              Privacy notice for <span>Job&nbsp;Applicants</span>,{' '}
              <span>Candidates</span> and <span>Interns</span>
            </h1>

            <div>
              <p>
                Data Wow Co. Ltd., and its affiliated (the "Company", "we",
                "us", or "our") takes protection of personal data as an
                important matter in our businesses. This Privacy notice Privacy
                notice describes how we collect, use and disclose personal data
                of job applicant, candidates and interns ("you" or "your"), and
                tells you about data protection rights in relation to your
                Personal Data in connection with recruiting procedures and
                programs.
              </p>
              <p>
                For the purpose of this Privacy notice, "Personal Data" means
                any information relating to an identified or identifiable
                natural person as listed below.
              </p>
              <p>
                We reserve the right to modify this Privacy notice from time to
                time, so please review it frequently to see when this Privacy
                notice was last revised. Any changes to this Privacy notice will
                become effective when we post the revised Privacy notice on our
                website, application or other means. We will provide additional
                notice of significant updates. In case any modification deprives
                your rights of Sensitive Data in relation to this Privacy
                notice, the Company will first obtain your consent, except as
                otherwise permitted by law.
              </p>
            </div>
          </div>
        </div>

        <div className='Document__divider'></div>

        <div className='Document__content'>
          <div className='container'>
            <h3>Personal Data We Collect</h3>
            <p>
              As part of recruiting procedures and programs, we may collect or
              obtain the following types of information which may include
              Personal Data about you during recruiting and job interview
              process, either submitted as part of the online application and/or
              through alternative channels i.e job boards, company’s website and
              professional recruiting firm, Social Media, Job Fair, Networking
              events, etc. We may also collect your Personal Data from other
              sources or through our affiliates, subsidiaries, other companies,
              or business partners. The specific type
            </p>
            <ol>
              <li>
                Personal details: such as title, full name, marital status, date
                and place of birth, age, gender, blood type, height, weight,
                military service, photograph, nationality, information on
                government-issued cards i.e. national identification card,
                passport, work permit, driving license and any other license
                and/or permit such as auditor license, and lawyer license), car
                registration book, personal loans, student loans, social media
                account, signatures, CV, Resumes, application form, bank account
                details and other identifiers;
              </li>
              <li>
                Contact details: such as mobile phone number, home telephone
                number, registered address, present address, e-mail address,
                information on household registration document, emergency
                contact details, Line ID, LinkedIn URL, and include other
                similar information and
              </li>
              <li>
                Information about your job: such as working experience and
                previous employment (including position, department and title
                history and salary and benefits from previous employment), work
                behavior, your education history, training history, certificates
                and qualifications.
              </li>
            </ol>
            <p>
              "Sensitive Data" means Personal Data classified by law as
              sensitive data. We will only collect, use and disclose Sensitive
              Data, and transfer it across borders, if we have received your
              explicit consent or as permitted by law.
            </p>
            <p>
              We will also collect, use, disclose and/or cross-border transfer
              the following Sensitive Data about you:
            </p>
            <ol>
              <li>health data and medical data</li>
              <li>criminal records; and</li>
              <li>
                sensitive data in the official identification document, such as
                religious.
              </li>
            </ol>
            <p>
              If you provide Personal Data about members of your family, next of
              kin, references and/or other dependents for the purposes set forth
              in the Privacy notice, it is your responsibility to inform them of
              their rights with respect to the contents of this Privacy notice
              as applicable to them. You are also responsible for obtaining any
              required consent from them, and ensuring that you have the right
              to provide their personal information to us.
            </p>
            <hr />

            <h3>Why We Process Your Personal Data</h3>
            <h4>The purpose of which you have given your consent:</h4>
            <p>
              Health and medical data: such as chronic health conditions or
              medical history and the information contained in a doctor's
              certificate/medical certificate for purposes of evaluating the
              respective suitability of applicants; information on disability
              for purposes of recruiting;
            </p>
            <p>
              Criminal records: in the event that we have conducted or received
              the results of criminal records and/or background checks in
              relation to you, where relevant and appropriate to your role for
              purposes of recruitment;
            </p>
            <p>
              Sensitive Data in the official identification documents: for
              authentication and verification purposes and welfare allocation
              (e.g. food preparation, provision of religious holiday, workforce
              planning and accommodating the work place).
            </p>
            <h4>
              The purposes we may rely on and other legal grounds for processing
              your Personal Data
            </h4>
            <p>We may also rely on:</p>
            <ol>
              <li>
                contractual basis, for our initiation or fulfilment of our
                employment agreement with you if you are an employee or work
                contract if you are a worker;
              </li>
              <li>
                legal obligation, for the fulfilment of our legal obligations;
              </li>
              <li>
                legitimate interest, for the purpose of our legitimate interests
                and the legitimate interests of third parties;
              </li>
              <li>
                vital interest, for preventing or suppressing a danger to a
                person’s life, body, or health; and/or
              </li>
              <li>
                public interest, for the performance of a task carried out in
                the public interest or for the exercise of official authorities.
              </li>
            </ol>
            <p>
              We may collect, use or disclose your Personal Data, including, but
              is not limited to, for the purposes of Recruitment management,
              including:
            </p>
            <p>
              Documenting information collected from job applicants as part of
              the application process, authentication and verification,
              contacting purposes, evaluating the respective suitability of
              applicants, making a hiring decision, defining a salary and other
              basic contract information for a new hire, execution of employment
              agreement and orientation process, evaluating job
              applicants/candidates for their qualification for a particular
              job, background screening (if you are offered a position with us),
              and communicating with your designated contacts in case of an
              emergency.
            </p>
            <hr />

            <h3>Disclosure of Your Personal Data</h3>
            <p>
              Your personal data will not be disseminated to third parties
              unless you have explicitly provided consent for the dissemination
              of your data, or there is an obligation for such dissemination as
              a result of statutory provisions and/or requirements by
              authorities or courts.
            </p>
            <p>
              We utilize third parties for supporting the search for applicants
              and for managing applicants. If third parties are engaged for such
              support, We ensures that they possess adequate security measures,
              in order to protect your data in accordance with the requirements
              that apply at Data Wow itself. We use a special applicant
              management system for carrying out the application
              process.  Pursuant to a separate agreement regarding the contract
              processing of personal data, your personal data will be collected,
              processed and used by the company.
            </p>
            <hr />

            <h3>Transferring Personal Data Overseas</h3>
            <ol>
              <li>
                We may send or transfer your personal data to our affiliates or
                other persons in a foreign country if it is necessary in order
                for us to perform our obligations in the contract to which you
                are the counterparty or contract between us and third party for
                your benefit, to respond to your pre-contractual request; to
                protect your and third party’s life, body and health, to comply
                with laws or to the extent necessary for the public interest
                activities.
              </li>
              <li>
                We may store your information on a computer, server, or cloud
                provided by a third party. And may use third-party programs,
                applications and platforms in processing your personal data.
                However, we will not allow unrelated parties to access to your
                personal data and will require such parties to have appropriate
                security protection measures.
              </li>
              <li>
                In the event that your personal data is transferred to a foreign
                country, we will comply with applicable personal data protection
                laws and take appropriate measures to ensure that your personal
                data is protected and you can exercise your rights in accordance
                with the laws. Moreover, we will require those who receive the
                data to have appropriate protection measures for your personal
                data, to process such personal data only as necessary, and to
                take steps to prevent unauthorized use or disclosure of your
                personal data.
              </li>
            </ol>
            <hr />

            <h3>Retention Period</h3>
            <ol>
              <li>
                We will retain your Personal Data for the period necessary to
                meet the objectives unless the law requires longer retention
                periods. In the event that such period is unclear, We will
                retain the data for a customary expected period in accordance
                with retention standards (e.g. the prescriptive period of 10
                years for general legal claims).
              </li>
              <li>
                The period we retain your personal data may varies according to
                each processing activity, which you can see further details in
                the related topic.
              </li>
              <li>
                We may retain your personal data after completion of the
                selection process of the position you apply to contact you in
                the event that there are other positions that we deem suitable
                for you. We will retain your personal data for a period of time
                necessary to achieve the purpose of enrollment or internship. If
                you do not want us to keep your personal data to be considered
                for other positions, you can contact us using the methods
                specified in this Privacy notice.
              </li>
              <li>
                If you are selected as our employee or intern, we will continue
                to collect your Personal Data for the duration that is necessary
                to meet the employment or internship objectives.
              </li>
              <li>
                If your Personal Data is processed based on consent, we will
                stop the processing when you have withdrawn the consent.
                However, we may keep your personal data to record your withdrawn
                so We can respond to your request in the future.
              </li>
              <li>
                We have established an auditing system to delete or destroy your
                personal data when the retention period expires or when it
                becomes irrelevant or unnecessary for the purposes of collecting
                that Personal Data.
              </li>
            </ol>
            <hr />

            <h3>Security Measures</h3>
            <p>
              The Company recognizes the importance of maintaining the security
              of your Personal Data. Therefore, the Company endeavors to protect
              your information by establishing security measures for your
              Personal Data appropriately and in accordance with the
              confidentiality safeguard of personal information, to prevent
              loss, unauthorized or unlawful access, destruction, use,
              alteration, or disclosure; provided however, that the Company will
              ensure that the method of collecting, storing and processing of
              your Personal Data, including physical safety measures follow the
              information technology security policies and guidelines of the
              Company.
            </p>
            <p>Data Wow is certified with ISO27001:2013</p>
            <hr />

            <h3>Your Rights as a Data Subject</h3>
            <p>
              Subject to applicable laws and exceptions thereof, you may have
              the following rights to:
            </p>
            <p>
              <strong>Access:</strong> You may have the right to access or
              request a copy of the Personal Data we are collecting, using and
              disclosing about you. For your own privacy and security,
            </p>
            <p>
              <strong>Rectification:</strong> You may have the right to have
              incomplete, inaccurate, misleading, or not up-to-date Personal
              Data that we collect, use and disclose about you rectified;
            </p>
            <p>
              <strong>Data Portability:</strong> You may have the right to
              obtain Personal Data we hold about you, in a structured,
              electronic format, and to send or transfer such data to another
              data controller, where this is (a) Personal Data which you have
              provided to us, and (b) if we are collecting, using and disclosing
              such data on the basis of your consent or to perform a contract
              with you;
            </p>
            <p>
              <strong>Objection:</strong> You may have the right to object to
              certain collection, use and disclosure of your Personal;
            </p>
            <p>
              <strong>Restriction:</strong> You may have the right to restrict
              the use of your Personal Data in certain circumstances;
            </p>
            <p>
              <strong>Withdraw Consent:</strong> For the purposes you have
              consented to our collecting, using and disclosing of your Personal
              Data, you have the right to withdraw your consent at any time;
            </p>
            <p>
              <strong>Deletion:</strong> You may have the right to request that
              we delete or de-identity Personal Data that we collect, use and
              disclose about you, except we are not obligated to do so if we
              need to retain such data in order to comply with a legal
              obligation or to establish, exercise, or defend legal claims;
            </p>
            <p>
              <strong>Lodge a complaint:</strong> You may have the right to
              lodge a complaint to the competent authority where you believe our
              collection, use and disclosure of your Personal Data is unlawful
              or noncompliant with applicable data protection law.
            </p>
            <hr />

            <h3>Our Contact Details</h3>
            <p>
              If you wish to contact us to exercise the rights relating to your
              Personal Data or if you have any queries about your Personal Data
              under this Privacy notice, please contact HR team to proceed your
              request at{' '}
              <a
                href='https://datawow.pdpaform.com'
                target='_blank'
                rel='noreferrer'
                className='highlight-link'
              >
                https://datawow.pdpaform.com
              </a>
            </p>

            <hr />
            <br />
            <p>This document was last updated on March 26, 2021</p>
          </div>
        </div>
      </div>

      <LazyLoad>
        <GetStarted />
      </LazyLoad>
    </React.Fragment>
  )
}

CareerPolicy.getLayout = function getLayout(page) {
  return <MainLayout>{page}</MainLayout>
}
